<template>

    <div class="background_holder">

        <transition name="background-classes-transition" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
         <div class='background_holder'>
            <img class='starbucks_logo' src="static/images/global/global_starbucksLogo.png" alt='logo'>
            <img class='global_background' src="static/images/global/global_bg.jpg" alt='gobal bg'>
            <img  class='global_background_bottom' src="static/images/global/global_bg_bottom.jpg" alt='gobal bg'>
        </div>
      </transition>
  
    </div>

</template>

<script>
/* eslint-disable */
import { eventBus } from '../EventBus';

export default {
  data() {
    return {};
  }
};
</script>


<style lang="scss">
// Media Query Breakpoints
$break-phone-s: only screen (max-height: 600px); //iphone 6 below
$break-phone-m: only screen and (max-height: 740px) ; //pixel2, iphone7plus
$break-phone-l: only screen and (min-height: 741px); //pixel2 XL, iphoneX
/* $break-tablet: only screen and (min-height: 901px) and (max-height: 1024px);  */

 %img{
        top: 0;
        width: 100%;
        height:100%;
        position:absolute;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top center;
      }

 %wrapper {
      .top {
        grid-area: header;
        box-sizing: border-box;
        border-bottom: 3px solid black;
        @extend %img;
      }

      .bottom {
        grid-area: footer;
        box-sizing: border-box;
        @extend %img;
      }

    }

    

.background_holder{

  width:100%;
  height:100%;
  position:absolute;

  .starbucks_logo{
      width: 20%;
      height:auto;
      display: inline-block;
      z-index:3;
      position:absolute;
      transform: translate(-50%, 0%);
      top:16%;
  }

  .global_background{
      left: 0px;
      top: 0px;
      width:100%;
      height:100%;
      z-index:1;
      position:absolute;
      background-repeat: no-repeat;
      background-size: cover;
  }

  .global_background_bottom{
    left: 0px;
      bottom: 0px;
      width:100%;
      height:auto;
      z-index:2;
      position:absolute;
      background-repeat: no-repeat;
      background-size: cover;
  }

}

    .bg {
      position: absolute;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: top center;
      width: 100%;
      height: 100%;
      overflow: hidden;
      animation-duration: 0.5s;
      z-index: 0;

      background-color: #1b1b1b;

      display: grid;
      grid-template-rows: 10% auto 10%;
      justify-items: center;


      @media #{$break-phone-m} {
          grid-template-rows: 15% auto 15%;
          }

      grid-template-areas: 
      "header"
      "mid"
      "footer";

      &.question1 {
        @extend %wrapper;
      }
      &.question2 {
        @extend %wrapper;
      }
      &.question3 {
        @extend %wrapper;
      }
      &.question4 {
        @extend %wrapper;
      }

      &.question5 {
        @extend %wrapper;

      }


    } // end. question
    
.fade-transition {
  transition: opacity 0.3s ease;
}
</style>


// WEBPACK FOOTER //
// src/components/BackgroundHolder.vue